module.exports = __webpack_public_path__ + "03_long_beige.ce4fb5e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/03_long_beige.png
// module id = rYG7
// module chunks = 0